import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../css/style.css';
import '../css/responsive.css';
import Logo from '../assets/logo.svg'; // Import SVG direktno kao komponentu

const Accommodation = () => {
    const { slug } = useParams();
    const navigate = useNavigate();
    const [accommodation, setAccommodation] = useState(null);
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Pozivamo API da dobijemo podatke o smeštaju
                const accommodationResponse = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/accommodations/${slug}`);
                setAccommodation(accommodationResponse.data);

                // Pozivamo API da dobijemo kategorije za ovaj smeštaj
                const categoriesResponse = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/accommodations/${slug}/categories`);

                // Uklanjanje duplikata prema `name` atributu
                const uniqueCategories = categoriesResponse.data.filter(
                    (category, index, self) =>
                        index === self.findIndex((cat) => cat.name.toLowerCase() === category.name.toLowerCase())
                );

                setCategories(uniqueCategories);
                setLoading(false);
            } catch (err) {
                console.error('Error fetching data:', err);
                setError('Failed to load accommodation details or categories.');
                setLoading(false);
            }
        };

        fetchData();
    }, [slug]);

    const handleCategoryClick = (categoryName) => {
        if (categoryName.toLowerCase() === 'what to visit'.toLowerCase()) {
            navigate(`/accommodations/${slug}/what-to-visit`);
        } else if (categoryName.toLowerCase() === 'restaurants, clubs and bars'.toLowerCase()) {
            navigate(`/accommodations/${slug}/restaurants-clubs-bars`);
        } else if (categoryName.toLowerCase() === 'shops, markets, and rentals'.toLowerCase()) {
            navigate(`/accommodations/${slug}/shops-and-markets`);
        } else if (categoryName.toLowerCase() === 'trips and excursions'.toLowerCase()) {
            navigate(`/accommodations/${slug}/trips-excursions`);
        } else if (categoryName.toLowerCase() === 'contact'.toLowerCase()) {
            navigate(`/accommodations/${slug}/contact-live`);
        } else if (categoryName.toLowerCase() === 'services'.toLowerCase()) {
            navigate(`/accommodations/${slug}/services`);
        } else if (categoryName.toLowerCase() === 'events'.toLowerCase()) {
            navigate(`/accommodations/${slug}/events`);
        }
        if (categoryName.toLowerCase() === 'restaurants, clubs and bars'.toLowerCase()) {
    navigate(`/accommodations/${slug}/restaurants-clubs-bars`);
}

    };
    

    if (loading) {
        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                fontFamily: 'Montserrat, sans-serif',
                backgroundColor: 'rgba(255, 255, 255, 0.7)', // Transparentna pozadina
            }}>
                <img
                    src={Logo} // Ucitavanje SVG fajla
                    alt="Loading logo"
                    style={{ width: '150px', marginBottom: '20px' }} // Stil za logo
                />
                <p style={{ fontSize: '20px', fontWeight: 'bold', margin: '0' }}>Loading accommodation...</p>
            </div>
        );
    }

    if (error) {
        return <p>{error}</p>;
    }

    if (!accommodation) {
        return <p>No accommodation details found.</p>;
    }

    return (
        <div className="accommodation-page">
            {/* Pozadinska slika */}
            <div
                className="accommodation-content"
                style={{
                    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${accommodation.cover_image ? process.env.REACT_APP_BACKEND_URL + '/' + accommodation.cover_image : '/storage/images/noimage.jpg'})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    width: '100vw',
                    height: 'calc(100vh - 120px)',
                    margin: '0',
                    padding: '0',
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                {/* Naslovi */}
                <div
                    className="accommodation-overlay"
                    style={{
                        '--title-margin': '170px 0 0 0',
                        '--title-padding': '0px',
                        '--subtitle-margin': '5px 0',
                        '--subtitle-padding': '5px',
                    }}
                >
                    <h1 className="accommodation-title">{accommodation.name}</h1>
                    <h2 className="accommodation-subtitle">
                        {accommodation.location}, {accommodation.country}
                    </h2>
                </div>

                {/* Kategorije kao dugmad */}
                <div className="button-container">
                    {categories.length > 0 ? (
                        categories.map((category) => (
                            <button
                                key={category.id || category.name} // Ključ sada može biti i ime ako ID nije dostupan
                                onClick={() => handleCategoryClick(category.name)}
                            >
                                {category.name}
                            </button>
                        ))
                    ) : (
                        <p>No categories available for this accommodation.</p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Accommodation;
